import "../styles/ourPartners.css";

const PARTNERS = [
  { file: "cib.svg", name: "CIB Bank" },
  { file: "cofidis.svg", name: "Cofidis" },
  { file: "erste.svg", name: "Erste Bank" },
  { file: "granit.svg", name: "Gránit Bank" },
  { file: "kh.svg", name: "K&H Bank" },
  { file: "magnet.svg", name: "MagNet Bank" },
  { file: "mbh.svg", name: "MBH Bank" },
  { file: "otp.svg", name: "OTP Bank" },
  { file: "raiffeisen.svg", name: "Raiffeisen Bank" },
  { file: "unicredit.svg", name: "UniCredit Bank" },
];

export default function OurPartners() {
  return (
    <section className="our-partners">
      <p className="our-partners-title">Partnereink</p>
      <div className="our-partners-grid">
        {PARTNERS.map((partner) => (
          <img
            key={partner.file}
            className="our-partners-logo"
            src={`${process.env.PUBLIC_URL}/logos/banks/${partner.file}`}
            alt={partner.name}
            title={partner.name}
          />
        ))}
      </div>
    </section>
  );
}
